module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/notes/edit-note/edit-note.component.css
// module id = ./src/app/notes/edit-note/edit-note.component.css
// module chunks = main